import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const INITIAL_STATE = {
    processingDecryptAccount: false,
    priceLoaded: false,
    globalPropertiesLoaded: false,
};
export const AppStatusReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case SteemActionType.SET_APP_STATUS:
            return Object.assign(Object.assign({}, state), payload);
        default:
            return state;
    }
};
